var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6293 10.87C9.5293 10.86 9.4093 10.86 9.2993 10.87C6.9193 10.79 5.0293 8.84 5.0293 6.44C5.0293 3.99 7.0093 2 9.4693 2C11.9193 2 13.9093 3.99 13.9093 6.44C13.8993 8.84 12.0093 10.79 9.6293 10.87Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.878 4C18.818 4 20.378 5.57 20.378 7.5C20.378 9.39 18.878 10.93 17.008 11C16.928 10.99 16.838 10.99 16.748 11",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.62945 14.56C2.20945 16.18 2.20945 18.82 4.62945 20.43C7.37945 22.27 11.8895 22.27 14.6395 20.43C17.0595 18.81 17.0595 16.17 14.6395 14.56C11.8995 12.73 7.38945 12.73 4.62945 14.56Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8086 20C19.5286 19.85 20.2086 19.56 20.7686 19.13C22.3286 17.96 22.3286 16.03 20.7686 14.86C20.2186 14.44 19.5486 14.16 18.8386 14",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.da2bc907042082c1fa5fa6749a843c1c.svg";
export { ForwardRef as ReactComponent };